import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import style from "./Header.module.css";

import Logo from "@/ui/logo/Logo";
import Navigation from "@/ui/navigation/Navigation";
import Button from "@/ui/button/Button";

import Icon from "@/ui/icon/Icon";
import ProfileDropdown from "@/ui/profileDropdown/ProfileDropdown";
import LanguageSwitcher from "@/ui/languageSwitcher/LanguageSwitcher";

import { useUser } from "@/features/auth/hooks/useUser";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME } from "@/utils/constants";

import SearchParent from "@/features/search/components/searchParent/SearchParent";

function Header() {
	const { isLoggedIn, isLoading } = useUser();
	const { pathname } = useLocation();
	const isMobile = useMediaQuery("(max-width: 900px)");

	// A visitor with no token is a visitor with no session — the same read
	// Home makes, and it settles before /auth/whoami/ does, so the field never
	// paints and then vanishes.
	const isGuest =
		!localStorage.getItem(AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME) ||
		(!isLoading && !isLoggedIn);

	// The phone landing page leads with the hero, and the search row sits on
	// top of it. There is nothing to search yet at that point either: the
	// catalogue is behind registration.
	const showSearch = !(isMobile && isGuest && pathname === "/");

	return (
		<header className={style.header}>
			<div className={style.content}>
				<div className={style.nav}>
					<Logo />
					<Navigation />
				</div>
				{showSearch && (
					<div className={style.searchHolder}>
						<SearchParent />
					</div>
				)}
				<div className={style.profileHolder}>
					{!isLoading &&
						(isLoggedIn ? <ProfileDropdown /> : <NotLoggedIn />)}
				</div>
			</div>
		</header>
	);
}

function NotLoggedIn() {
	const { t } = useTranslation();

	return (
		<div className={style.notLoggedIn}>
			<LanguageSwitcher />
			<Button to="login" className={style.login}>
				<Icon icon="fa-user" />
				{t("common:nav.login")}
			</Button>
			<Button to="register" className={style.register}>
				{t("common:nav.register")}
				<Icon icon="fa-arrow-up-right" />
			</Button>
		</div>
	);
}

export default Header;
